module.exports = __webpack_public_path__ + "static/media/8.e1683934.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/PhuketSkypark/sitePlan/svg/b/8.png
// module id = 972
// module chunks = 0